import type { UpdaterPort } from "./types";

/** 웹은 OTA 가 없다(배포 = 새 페이지 로드). */
export const webUpdater: UpdaterPort = {
  async check() {
    return null;
  },
  async apply() {},
  async reset() {},
  async currentBundle() {
    return null;
  },
};
